import React from "react";
import ReactDOM from "react-dom";
import {
    ConflictResolution,
    DesignConflictSectionsContainer,
    mapDesignConflictItems,
    resolveDesignConflictItems
} from '../../utilities';

/**
 * UI for merging application versions with options for resolving conflicts 
 *
 * @class MergeConflictDialog
 * @extends {React.Component}
 */
export class MergeConflictDialog extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            conflictSections: props.conflictSections,
            showUnresolved: false
        };
    }

    static open({
        /** {DesignConflictSection[]} List of conflicts between source and target designs. */
        conflictSections,
        /** {DesignChangeMap} Changes on source. */
        sourceChangeMap,
        /** {string} Label for the source design. */
        sourceLabel,
        /** {string} Label for the target design. */
        targetLabel
    }) {
        return new Promise((resolve) => {
            const buttonsSelector = '#w2ui-popup .w2ui-popup-buttons';
            const dialogId = 'conflict-dialog';

            window.apm.popup(
                'Resolve Conflicts',
                `<div id="${dialogId}" style="height: 98%"></div>`,
                [
                    `<button class="w2ui-btn secondary cancel-button">${window.l.popup.cancel}</button>`,
                    '<button class="w2ui-btn primary" id="acceptConflictChanges">Accept Changes</button>'
                ].join(''),
                [
                    `#${dialogId}`,
                    () => {
                        // Dialog elements.
                        const cancelButton = document.querySelector(`${buttonsSelector} .cancel-button`);
                        const acceptChangesButton = document.querySelector(`${buttonsSelector} #acceptConflictChanges`);
                        const dialogContainer = document.getElementById(dialogId);

                        const closeDialog = () => {
                            ReactDOM.unmountComponentAtNode(dialogContainer);
                            w2popup.close();
                        };

                        const dialogContent = (
                            <MergeConflictDialog
                                conflictSections={conflictSections}
                                setConflictSections={(c) => {
                                    conflictSections = c;
                                }}
                                sourceLabel={sourceLabel}
                                targetLabel={targetLabel}
                            />
                        );

                        const mergeConflictDialog = ReactDOM.render(
                            dialogContent,
                            dialogContainer
                        );

                        cancelButton.addEventListener('click', () => {
                            closeDialog();
                            resolve(null);
                        });

                        acceptChangesButton.addEventListener('click', async () => {
                            const conflictItems = [];
                            mapDesignConflictItems(conflictSections, (item) => {
                                conflictItems.push(item);
                            });
                            const unresolvedConflictsExist = conflictItems.some((item) => {
                                return item.resolution === ConflictResolution.none;
                            });
                            if (unresolvedConflictsExist) {
                                // Smoothly scroll to the first unresolved conflict container.
                                mergeConflictDialog.setState({
                                    showUnresolved: true
                                });
                                const conflictWrapper = document.querySelector(
                                    '[data-is-resolved="false"]'
                                );
                                conflictWrapper.scrollIntoView({ behavior: 'smooth' });
                                return;
                            }

                            closeDialog();
                            resolve(resolveDesignConflictItems(
                                sourceChangeMap,
                                conflictItems
                            ));
                        });
                    }
                ],
                620, // height
                null, // node
                null, // treenode
                false, // showClose
                926 // width
            );
        });
    }

    /**
     * React render
     * @returns {XML}
     */
    render() {
        const {
            setConflictSections,
            sourceLabel,
            targetLabel
        } = this.props;
        const {
            conflictSections,
            showUnresolved
        } = this.state;

        return (
            <DesignConflictSectionsContainer
                sections={conflictSections}
                setSections={(sections) => {
                    setConflictSections(sections);
                    this.setState({ conflictSections: sections });
                }}
                showUnresolved={showUnresolved}
                sourceLabel={sourceLabel}
                targetLabel={targetLabel}
            />
        );

    }
}
